'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var locale = {
    placeholder: '请选择时间'
};
exports['default'] = locale;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/time-picker/locale/zh_CN.js
// module id = 485
// module chunks = 0